import { axiosInstance } from '~/quality-management/api'

import type { IUserData } from './types'

export const userApi = {
	getUserData: async (): Promise<{data: IUserData}> => {
		return axiosInstance.get('/users/me')
	}
}
